module.exports = __webpack_public_path__ + "img/fal-clock.4311ea45.svg";